import { OnInit, Component } from "@angular/core";
import { Router } from "@angular/router";

import { GlobalComponent, UserLogin } from "../environments/global";

@Component({
	selector: "app-home",
	templateUrl: "home.component.html",
	styleUrls: ["home.component.scss"],
})
export class HomeComponent implements OnInit {
	public isCollapsed: boolean;
	public isRestricted: boolean;

	// ################################################
	// CLASS: CONSTRUCTOR
	constructor(private router: Router, public g: GlobalComponent) {}
	// ################################################
	// CLASS: ON INIT
	ngOnInit() {
		if (!this.g.checkLogin()) {
			this.router.navigateByUrl("/admin");
			return;
		}

		this.isRestricted = this.g.userLogin.restricted || this.g.userLogin.onlyorders;

		if (!this.isRestricted) {
			this.g.homeTitle = "WebCheck Amministrazione";
		} else {
			this.g.homeTitle = "WebCheck Gestione";
			this.router.navigateByUrl("/home/(homeContent:ordini)");
		}
	}
	// ################################################
	// LOGOUT
	logOut() {
		this.g.userLogin = {} as UserLogin;
		this.g.menuState = 0;
		sessionStorage.setItem("webcheck", JSON.stringify(this.g.userLogin));
		this.router.navigateByUrl("/admin");
	}
}
